import { useEffect, useState } from 'react';
import './Dashboard.css';

const DashboardOverview = () => {
  const [usage, setUsage] = useState({ sms: 0, calls: 0, images: 0 });

  useEffect(() => {
    const sms = Number(localStorage.getItem('usage_sms') || 0);
    const calls = Number(localStorage.getItem('usage_calls') || 0);
    const images = Number(localStorage.getItem('usage_images') || 0);
    setUsage({ sms, calls, images });
  }, []);

  return (
    <div className="dashboard-overview">
      <div className="overview-hero animate-fadein">
        <div>
          <p className="usage-label">Dashboard</p>
          <h2>Usage overview and activity</h2>
          <p className="muted-text">Track how much you have used SMS, Calls, and Prompt Services.</p>
        </div>
      </div>

      <div className="usage-panel animate-fadein">
        <div className="usage-header">
          <div>
            <p className="usage-label">Usage Overview</p>
            <h3>Track your activity at a glance</h3>
          </div>
          <span className="usage-chip">Auto-updates after each action</span>
        </div>
        <div className="usage-grid">
          <div className="usage-card sms">
            <div className="usage-icon">📩</div>
            <p className="usage-title">SMS Sent</p>
            <p className="usage-value">{usage.sms}</p>
            <p className="usage-hint">Messages delivered via your workspace</p>
          </div>
          <div className="usage-card calls">
            <div className="usage-icon">📞</div>
            <p className="usage-title">Calls Placed</p>
            <p className="usage-value">{usage.calls}</p>
            <p className="usage-hint">Outbound calls initiated</p>
          </div>
          <div className="usage-card images">
            <div className="usage-icon">🎨</div>
            <p className="usage-title">Images Generated</p>
            <p className="usage-value">{usage.images}</p>
            <p className="usage-hint">AI images created from prompts</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardOverview;
